// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TjR0m","moreInfos":"styles_moreInfos__yed94","contentWrapper":"styles_contentWrapper__A7jkU","arrow":"styles_arrow__v5ls5"};